import * as React from 'react'
import SessionSpeaker from './SessionSpeaker'
import AddToCalendar from '@culturehq/add-to-calendar'
import { ProgrammeSession } from '../Programme'
import { JoinButton } from './JoinButton'
import { SessionState } from './SessionState'

const SessionCard: React.FC<ProgrammeSession> = ({
  id,
  title,
  desc,
  startAt,
  endAt,
  date,
  time,
  day,
  hall,
  speakers,
  subsessions,
  secondsTillStart,
  durationInSeconds,
  hasPlayback,
  ended,
}) => {
  return (
    <>
      <div className='card mb-2 p-3 p-md-4 border-2' style={{ backgroundColor: ended ? '#f4f4f4' : 'white' }}>
        <div className="row">
          <div className="col-7">
            <p className="font-weight-bold mb-2">{date}</p>
            <p className="font-weight-bold mb-2">{time}</p>
            <p className="font-weight-bold text-red mb-2">{title}</p>
            {desc ? <p className="fw-bold text-muted mb-2">{desc}</p> : null}
            <small className="text-muted d-block mb-2 font-weight-bold font-italic">
              DAY {day} | {hall}
            </small>
          </div>
          <div className="col-5 pt-1 flex-child">
            <div className="cardAction">
              <SessionState secondsTillStart={secondsTillStart} durationInSeconds={durationInSeconds} />
              <AddToCalendar
                children={<small className="d-block ml-1">ADD TO CALENDAR</small>}
                filename={title}
                event={{
                  name: title,
                  details: 'MOA 2022',
                  location: hall,
                  startsAt: startAt,
                  endsAt: endAt,
                }}
              />
            </div>
            <JoinButton hasPlayback={hasPlayback} sessionId={id} secondsTillStart={secondsTillStart} durationInSeconds={durationInSeconds} />
          </div>
        </div>

        {speakers.length ? (
          <div className="mt-4">
            {speakers.map(({ id, fullName, avatar }) => (
              <SessionSpeaker id={id} key={id} fullName={fullName} avatar={avatar} />
            ))}
          </div>
        ) : null}

        {subsessions.length > 0 && (
          <>
            <hr />

            <div className="subsessions">
              {subsessions.map((ss) => (
                <div key={ss.id}>
                  <div className="font-weight-bold mt-3 mb-3 text-warning" dangerouslySetInnerHTML={{ __html: ss.title }} />
                  {ss.chairpersons.length ? (
                    <div className="ps-1 mt-2 mb-3">
                      <small className="d-block mb-2 font-weight-bold text-muted">Chairperson</small>
                      {ss.chairpersons.map(({ id, fullName, avatar }) => (
                        <SessionSpeaker id={id} key={id} fullName={fullName} avatar={avatar} />
                      ))}
                    </div>
                  ) : null}
                  {ss.timeslots.map((ts) => (
                    <div className="card border bg-light p-3 mb-2" key={ts.id}>
                      <p className="mb-2 font-weight-bold text-primary">{ts.time}</p>
                      <p className="font-weight-bold mb-2">{ts.title}</p>
                      <div className="mt-2 row">
                        {ts.speakers.map(({ id, fullName, avatar }) => (
                          <div className="col-6" key={id}>
                            <SessionSpeaker id={id} fullName={fullName} avatar={avatar} />
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  )
}

export default SessionCard
